import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  SystemTemplates,
  UpdateSystemTemplatePayload,
} from 'models/automation/SystemTemplates';
import API from 'services/API';
import { SYSTEM_TEMPLATES_BASE_QUERY_KEY } from './useFetchSystemTemplates';

type UpdateSystemTemplateMutationArgs = UpdateSystemTemplatePayload & {
  key: SystemTemplates;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, UpdateSystemTemplateMutationArgs>,
  'mutationFn' | 'mutationKey'
>;

const updateSystemTemplate = ({
  key,
  ...payload
}: UpdateSystemTemplateMutationArgs) => {
  return API.put<{}, BaseErrorResponse>(
    `/api/internal/automation/system-templates/${key}/contents`,
    payload,
  );
};

const useUpdateSystemTemplateMutation = ({
  onSuccess,
  ...options
}: ReactQueryMutationOptions = {}) => {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: updateSystemTemplate,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([SYSTEM_TEMPLATES_BASE_QUERY_KEY]);
      return onSuccess?.(...args);
    },
    ...options,
  });
};

export default useUpdateSystemTemplateMutation;
